import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../redux/actions";
import Loader from "../components/Loader";
import axios from "axios";
import { env } from "../config";
import Footer from "../components/Footer";
const ApplicationDevelopmentPageIntro = React.lazy(
  () => import("../components/ApplicationDevelopmentPage ntro")
);
const DevelopmentPagesCards = React.lazy(
  () => import("../components/DevelopmentPagesCards")
);
const ContactUsSection = React.lazy(
  () => import("../components/ContactUsSection")
);

function ApplicationDevelopmentPage(props: any) {
  const ApplicationDevelopmentData: any = useSelector(
    (state: any) => state?.Page?.ApplicationDevelopmentPageContent
  );

  const dispatch = useDispatch();

  let url = "/api/application-development-page-content?populate=deep";
  let action = Actions.ApplicationDevelopmentpageAction;

  useEffect(() => {
    if (Object.keys(ApplicationDevelopmentData).length === 0) {
      setTimeout(() => {
        (async () => {
          await axios
            .get(`${env}${url}`)
            .then(function (response) {
              dispatch(action(response?.data?.data?.attributes));
            })
            .catch((error: any) => {
              console.log("error", error);
            });
        })();
      }, 0);
    }
    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, [dispatch]);

  const isLoading = Object.keys(ApplicationDevelopmentData).length === 0;

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <Suspense fallback={<Loader />}>
        <ApplicationDevelopmentPageIntro
          ApplicationDevelopmentPageIntro={
            ApplicationDevelopmentData?.ApplicationDevelopmentPageIntro
          }
        />

        <DevelopmentPagesCards
          AppDevelopmentCardsSection={
            ApplicationDevelopmentData?.AppDevelopmentCardsSection
          }
          gridValues="grid md:grid-cols-2 lg:grid-cols-2"
        />

        <ContactUsSection
          ContactUsSection={ApplicationDevelopmentData?.ConnectSection}
        />
        <Footer />
      </Suspense>
    </div>
  );
}

export default ApplicationDevelopmentPage;
